// -------------- Tooltip logic
document.addEventListener('DOMContentLoaded', () => {
  const mediaQuery = window.matchMedia('(min-width: 750px)');

  document.querySelectorAll('.lord-info').forEach(icon => {
    const tooltip = icon.nextElementSibling;
    if (!tooltip || !tooltip.classList.contains('lord-tooltip')) {
      return;
    }

    let hideTimer;

    const showTooltip = () => {
      // Only run this logic on desktop
      if (mediaQuery.matches) {
        clearTimeout(hideTimer);
        tooltip.classList.add('tooltip-visible');
      }
    };

    const startHideTimer = () => {
      // Only run this logic on desktop
      if (mediaQuery.matches) {
        hideTimer = setTimeout(() => {
          tooltip.classList.remove('tooltip-visible');
        }, 150); // 150ms delay allows moving mouse from icon to tooltip
      }
    };

    // Desktop Hover Listeners (>= 750px)
    icon.addEventListener('mouseenter', showTooltip);
    tooltip.addEventListener('mouseenter', showTooltip); // Keep it open when hovering tooltip
    icon.addEventListener('mouseleave', startHideTimer);
    tooltip.addEventListener('mouseleave', startHideTimer); // Hide when leaving tooltip

    // Mobile Click Listener (< 750px)
    icon.addEventListener('click', (e) => {
      // Only run this logic on mobile
      if (!mediaQuery.matches) {
        e.stopPropagation();
        const isVisible = tooltip.classList.contains('tooltip-visible');
        document.querySelectorAll('.lord-tooltip.tooltip-visible').forEach(tt => {
          if (tt !== tooltip) {
            tt.classList.remove('tooltip-visible');
          }
        });
        tooltip.classList.toggle('tooltip-visible');
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (!mediaQuery.matches) {
      const visibleTooltip = document.querySelector('.lord-tooltip.tooltip-visible');
      
      if (visibleTooltip) {
        const icon = visibleTooltip.previousElementSibling;
        if (!visibleTooltip.contains(e.target) && e.target !== icon) {
          visibleTooltip.classList.remove('tooltip-visible');
        }
      }
    }
  });
});


// ------------ Gift Card Logic
document.addEventListener('DOMContentLoaded', () => {
  // ELEMENT SELECTORS (for elements available on page load)
  const sliderImagesContainer = document.getElementById('slider-images-container');
  const thumbnailContainer = document.getElementById('thumbnail-container');
  const modal = document.getElementById('gc-modal');
  const modalMessage = document.getElementById('gc-modal-message');
  const modalSpinner = document.getElementById('gc-modal-spinner');
  const modalActions = document.getElementById('gc-modal-actions');
  const modalCloseWrapper = document.getElementById('gc-modal-close-wrapper');
  const modalContinueBtn = document.getElementById('gc-modal-continue-btn');
  const modalCloseBtn = document.getElementById('gc-modal-close-btn');
  const modalSuccessIcon = document.getElementById('gc-modal-success-icon');

  const lordsInfoWrapper = document.getElementById('lords-info-wrapper');

  // MODAL HELPER FUNCTIONS
  function showModal(message, state = 'loading') {
    modalMessage.textContent = message;
    modalSpinner.style.display = state === 'loading' ? 'block' : 'none';
    modalSuccessIcon.style.display = state === 'success' ? 'block' : 'none';
    modalActions.style.display = state === 'success' ? 'flex' : 'none';
    modalCloseWrapper.style.display = state === 'error' ? 'flex' : 'none';
    modal.style.display = 'flex';
  }

  function hideModal() {
    modal.style.display = 'none';
  }

  modalCloseBtn.addEventListener('click', hideModal);
  modal.addEventListener('click', (event) => {
    if (event.target === modal) hideModal();
  });

  // Robust check function with immediate cleanup if price stays 0
  async function pollForCartUpdate(lineItemKey, expectedPriceInCents, maxAttempts = 10, delay = 800) {
    for (let i = 0; i < maxAttempts; i++) {
      await new Promise(resolve => setTimeout(resolve, delay));
      const cart = await (await fetch('/cart.js')).json();
      const addedItem = cart.items.find(item => item.key === lineItemKey);
      if (addedItem && addedItem.price === expectedPriceInCents) {
        console.log(`Price confirmed for item ${lineItemKey} on attempt ${i + 1}.`);
        return { success: true, cart: cart };
      }
      if (addedItem && addedItem.price === 0) {
        console.log(`Attempt ${i + 1}/${maxAttempts}: Item price is still 0. Retrying...`);
        continue;
      }
      console.log(`Attempt ${i + 1}/${maxAttempts}: Waiting for item ${lineItemKey} to appear with the correct price.`);
    }
    console.error(`Polling timed out for item ${lineItemKey}. The price did not update correctly.`);
    const finalCart = await (await fetch('/cart.js')).json();
    const lingeringItem = finalCart.items.find(item => item.key === lineItemKey);
    if (lingeringItem) {
      console.warn(`Timeout: Removing item ${lineItemKey} from cart.`);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lingeringItem.key, quantity: 0 })
      });
    }
    return {
      success: false,
      error: 'Could not confirm the gift card price. The item has been removed from your cart. Please try again.'
    };
  }

  // MAIN APP LOGIC
  const getCardTypeFromPublicId = (publicId) => {
    if (publicId.includes('Happy-bday-giftcard')) return 'Happy Birthday Gift Card';
    if (publicId.includes('merry-chris')) return 'Merry Christmas Gift Card';
    if (publicId.includes('thank-you')) return 'Thank You Gift Card';
    if (publicId.includes('gift-card')) return 'Digital Gift Card';
    return 'Gift Card';
  };

  fetch('https://gift-card-functionality-production.up.railway.app/api/images/categories')
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch image categories.');
      return response.json();
    })
    .then(data => {
      const apiCategories = data.data.categories || [];
      const tabListContainer = document.getElementById('card-type-tab-list');
      const categoryImageData = new Map();
      
      //Add a flag to track if Lord's tab exists
      let lordsCategoryExists = false;

      if (!tabListContainer) {
        console.error('Tab list container (#card-type-tab-list) not found.');
        return;
      }

      tabListContainer.innerHTML = '';
      if (lordsInfoWrapper) {
        // Hide it by default. Will show it later if the flag is set.
        lordsInfoWrapper.style.display = 'none';
      }

      const loader = document.getElementById('custom-gc-loader');
      sliderImagesContainer.innerHTML = '';
      thumbnailContainer.innerHTML = '';
      let slides = [];
      let thumbnails = [];
      
      const giftCardData = {
        cardType: 'Digital Gift Card',
        imageUrl: '',
        amount: null,
        sendAsGift: false,
        recipient: { name: '', email: '', message: '' },
        addVideo: false,
        delivery: { type: 'now', dateTime: null }
      };

      // variable declarations
      const giftCardForm = document.getElementById('custom-gift-card-form');
      const tabs = document.querySelectorAll('.custom-gc-tab-link');
      const tabPanes = document.querySelectorAll('.custom-gc-tab-pane');
      const selectedCardNameDisplay = document.getElementById('selected-card-name');
      const prevBtn = document.getElementById('prev-slide');
      const nextBtn = document.getElementById('next-slide');
      const amountBtns = document.querySelectorAll('.custom-gc-amount-btn');
      const customAmountInput = document.getElementById('custom-amount-input');
      const sendAsGiftCheckbox = document.getElementById('send-as-gift-checkbox');
      const recipientFields = document.getElementById('recipient-fields');
      const recipientNameInput = document.getElementById('recipient-name');
      const recipientEmailInput = document.getElementById('recipient-email');
      const recipientMessageInput = document.getElementById('recipient-message');
      const videoCheckbox = document.getElementById('video-checkbox');
      const deliveryBtns = document.querySelectorAll('.custom-gc-delivery-btn');
      const datePickerInput = document.getElementById('delivery-date-picker');
      const agreeCheckbox = document.getElementById('agree-checkbox');
      const addToCartBtn = document.getElementById('add-to-cart-btn');
      const checkBalanceInput = document.getElementById('gift-card-number-input');
      const checkBalanceBtn = document.getElementById('check-balance-btn');
      const balanceResultDisplay = document.getElementById('balance-result-display');
      let currentSlide = 0;

      // START: Code for Message Limit
      const MAX_MESSAGE_LENGTH = 500;
      recipientMessageInput.setAttribute('maxlength', MAX_MESSAGE_LENGTH);
      const messageCounter = document.createElement('small');
      messageCounter.id = 'recipient-message-counter';
      messageCounter.style.display = 'block';
      messageCounter.style.marginTop = '5px';
      messageCounter.style.textAlign = 'right';
      messageCounter.style.color = '#555';
      if (recipientMessageInput.parentNode) {
        recipientMessageInput.parentNode.insertBefore(messageCounter, recipientMessageInput.nextSibling);
      }
      function updateMessageCounter() {
        const currentLength = recipientMessageInput.value.length;
        messageCounter.textContent = `${currentLength} / ${MAX_MESSAGE_LENGTH}`;
        if (currentLength >= MAX_MESSAGE_LENGTH) {
          messageCounter.style.color = '#D93025';
          messageCounter.style.fontWeight = 'bold';
        } else {
          messageCounter.style.color = '#555';
          messageCounter.style.fontWeight = 'normal';
        }
      }
      recipientMessageInput.addEventListener('input', updateMessageCounter);
      updateMessageCounter();
      // END: Code for Message Limit

      videoCheckbox.addEventListener('change', () => {
        giftCardData.addVideo = videoCheckbox.checked;
      });
      
      function setMinDateTime() {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        const offset = tomorrow.getTimezoneOffset();
        const localDate = new Date(tomorrow.getTime() - (offset * 60 * 1000));
        datePickerInput.min = localDate.toISOString().slice(0, 16);
      }

      function updateSlide() {
        if (slides.length === 0) {
          selectedCardNameDisplay.textContent = 'Gift Card';
          return;
        }
        slides.forEach((slide, index) => slide.classList.toggle('active', index === currentSlide));
        const currentSlideEl = slides[currentSlide];
        giftCardData.cardType = currentSlideEl.dataset.cardType;
        giftCardData.imageUrl = currentSlideEl.src;
        selectedCardNameDisplay.textContent = giftCardData.cardType;
        let activeThumbnail = null;
        thumbnails.forEach((thumbnail, index) => {
          const isActive = index === currentSlide;
          thumbnail.classList.toggle('active-thumbnail', isActive);
          if (isActive) {
            activeThumbnail = thumbnail;
          }
        });
        if (activeThumbnail) {
          activeThumbnail.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      }

      function updateAddToCartButtonState() {
        addToCartBtn.disabled = !agreeCheckbox.checked;
      }

      function resetGiftCardForm() {
        giftCardForm.reset();
        amountBtns.forEach(btn => btn.classList.remove('active'));
        customAmountInput.classList.add('hidden');
        recipientFields.classList.add('hidden');
        const datePickerWrapper = document.getElementById('delivery-date-wrapper');
        if (datePickerWrapper) {
          datePickerWrapper.classList.add('hidden');
        }
        document.querySelector('.custom-gc-delivery-btn[data-delivery="later"]').classList.remove('active');
        document.querySelector('.custom-gc-delivery-btn[data-delivery="now"]').classList.add('active');
        Object.assign(giftCardData, {
          amount: null,
          sendAsGift: false,
          recipient: { name: '', email: '', message: '' },
          addVideo: false,
          delivery: { type: 'now', dateTime: null }
        });
        currentSlide = 0;
        updateSlide();
        agreeCheckbox.checked = true;
        updateAddToCartButtonState();
        if (typeof updateMessageCounter === 'function') {
          updateMessageCounter();
        }
      }

      function populateSlider(imageData) {
        if (loader) loader.style.display = 'flex';
        sliderImagesContainer.innerHTML = '';
        thumbnailContainer.innerHTML = '';
        slides = [];
        thumbnails = [];
        if (!imageData || imageData.length === 0) {
          sliderImagesContainer.innerHTML = '<p>No card designs found for this category.</p>';
          if (loader) {
             loader.classList.add('hidden');
             setTimeout(() => { loader.style.display = 'none'; }, 400);
          }
          updateSlide();
          return;
        }
        imageData.forEach((image, index) => {
          const cardType = getCardTypeFromPublicId(image.publicId);
          const slideImg = document.createElement('img');
          slideImg.src = image.url;
          slideImg.dataset.cardType = cardType;
          slideImg.classList.add('custom-gc-slide');
          sliderImagesContainer.appendChild(slideImg);
          slides.push(slideImg);
          slideImg.addEventListener('load', () => {
            if (index === 0 && loader) {
              loader.classList.add('hidden');
              setTimeout(() => { loader.style.display = 'none'; }, 400);
            }
          });
          const thumbImg = document.createElement('img');
          thumbImg.src = image.url;
          thumbImg.dataset.index = index;
          thumbImg.classList.add('custom-gc-thumbnail');
          thumbnailContainer.appendChild(thumbImg);
          thumbnails.push(thumbImg);
        });
        thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', () => {
            currentSlide = parseInt(thumbnail.dataset.index);
            updateSlide();
          });
        });
        currentSlide = 0;
        updateSlide();
      }
      
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(item => item.classList.remove('active'));
          tabPanes.forEach(pane => pane.classList.remove('active'));
          tab.classList.add('active');
          document.getElementById(tab.dataset.tab).classList.add('active');
        });
      });
      
      //Dynamic Tab Generation Logic
      apiCategories.forEach((category, index) => {
        const imagesForSlider = category.styles.map(style => ({
          url: style.secureUrl,
          publicId: style.publicId
        }));

        if (category.name.toLowerCase().includes('digital')) {
          const defaultImageIndex = imagesForSlider.findIndex(img => img.publicId.includes('gift-card'));
          if (defaultImageIndex > 0) {
            const [defaultImage] = imagesForSlider.splice(defaultImageIndex, 1);
            imagesForSlider.unshift(defaultImage);
          }
        }
        
        categoryImageData.set(category._id, imagesForSlider);

        const tab = document.createElement('div');
        tab.classList.add('card-type-tab');
        
        const categoryName = category.name.toLowerCase();
        let tabId = 'digital';
        if (categoryName.includes("lord's")) {
          tabId = 'lords';
        } else if (categoryName.includes('digital')) {
          tabId = 'digital';
        } else {
          tabId = categoryName.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        }
        tab.dataset.tabId = tabId;

        const isLordsTab = tabId === 'lords';

        //If Lord's tab, set flag to true
        if (isLordsTab) {
          lordsCategoryExists = true;
          // Add SVG and Name
          tab.innerHTML = `
            <svg class="lord-svg" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_11630_12171)">
            <path d="M29.1519 10.5522C28.8023 9.70928 27.694 9.27122 27.1925 8.52203C26.687 7.76709 26.7035 6.57653 26.0634 5.93641C25.4234 5.29628 24.2328 5.31278 23.4778 4.80734C22.7286 4.30572 22.2906 3.19747 21.4477 2.84797C20.6192 2.50441 19.5272 2.97484 18.6269 2.79672C18.3183 2.73572 18.0154 2.58941 17.712 2.42578H16.6117L14.444 2.62891L13.3924 2.90791L10.7525 4.85022L8.19855 6.05209L7.63842 8.25197C7.63842 8.25197 5.83773 10.2265 5.75186 10.3767C5.7118 10.4468 5.72317 11.1619 5.74011 11.9113H28.6519L29.2761 11.496C29.2924 11.1623 29.2717 10.8412 29.1519 10.5522Z" fill="#FFD500"/>
            <path d="M6.27212 10.5522C6.62168 9.70932 7.72993 9.27132 8.23149 8.52207C8.73693 7.76713 8.72043 6.57657 9.36056 5.93644C10.0007 5.29638 11.1912 5.31282 11.9462 4.80738C12.6954 4.30582 13.1334 3.19757 13.9763 2.848C14.8047 2.5045 15.8967 2.97488 16.7971 2.79682C17.1057 2.73582 17.4086 2.5895 17.7121 2.42588C17.156 2.12619 16.5981 1.76807 16 1.76807C15.0754 1.76807 14.247 2.624 13.3731 2.79688C12.4727 2.975 11.3807 2.50457 10.5523 2.84807C9.70943 3.19757 9.27137 4.30582 8.52218 4.80744C7.76724 5.31288 6.57668 5.29638 5.93656 5.9365C5.29649 6.57657 5.31293 7.76713 4.80749 8.52213C4.30593 9.27132 3.19762 9.70932 2.84812 10.5523C2.72824 10.8413 2.70762 11.1624 2.72381 11.4963L3.25156 11.9115H6.67549L6.14774 11.4963C6.13162 11.1623 6.15224 10.8413 6.27212 10.5522Z" fill="#FBC700"/>
            <path d="M17.6138 6.05469H16.204L13.2745 7.30825L10.6668 9.84081L9.82495 11.9119H24.6278L25.0121 11.4966C23.5866 8.65581 20.8569 6.57919 17.6138 6.05469Z" fill="#F27182"/>
            <path d="M17.6137 6.05409C17.088 5.96903 16.5493 5.92334 16 5.92334C12.0617 5.92334 8.64442 8.19472 6.98792 11.496L7.4366 11.9113H10.6642L10.2154 11.496C11.6409 8.65522 14.3707 6.57859 17.6137 6.05409Z" fill="#ED5469"/>
            <path d="M17.6136 8.63818H16.5472L14.122 9.73312C14.122 9.73312 13.3307 10.8976 12.6511 11.9116H21.2259L22.0874 11.4963C21.0044 10.0659 19.4291 9.02918 17.6136 8.63818Z" fill="#ED5469"/>
            <path d="M17.6137 8.63768C17.0934 8.52568 16.5536 8.46631 15.9999 8.46631C13.5138 8.46631 11.3057 9.6555 9.91248 11.4958L10.4305 11.9111H13.6581L13.14 11.4958C14.2229 10.0654 15.7983 9.02868 17.6137 8.63768Z" fill="#E63850"/>
            <path d="M29.1516 21.4475C28.8021 22.2904 27.6938 22.7284 27.1922 23.4776C26.6868 24.2326 26.7033 25.4231 26.0632 26.0633C25.4231 26.7034 24.2326 26.6869 23.4776 27.1923C22.7284 27.6939 22.2904 28.8022 21.4474 29.1517C20.619 29.4953 19.527 29.0248 18.6266 29.2029C18.3181 29.2639 18.0152 29.4103 17.7117 29.5739H16.6114L14.4437 29.3708L13.3921 29.0918L10.7523 27.1494L8.1983 25.9476L7.63818 23.7477C7.63818 23.7477 5.83749 21.7732 5.75162 21.6229C5.71155 21.5528 5.72293 20.8378 5.73987 20.0884H28.6516L29.2759 20.5036C29.2921 20.8374 29.2714 21.1585 29.1516 21.4475Z" fill="#FFD500"/>
            <path d="M6.27212 21.4477C6.62168 22.2906 7.72993 22.7286 8.23149 23.4778C8.73693 24.2328 8.72043 25.4233 9.36056 26.0634C10.0007 26.7035 11.1912 26.6871 11.9462 27.1925C12.6954 27.6941 13.1334 28.8024 13.9763 29.1519C14.8047 29.4954 15.8967 29.025 16.7971 29.2031C17.1057 29.2641 17.4086 29.4104 17.7121 29.574C17.156 29.8737 16.5981 30.2318 16 30.2318C15.0754 30.2318 14.247 29.3759 13.3731 29.203C12.4727 29.0249 11.3807 29.4953 10.5523 29.1518C9.70943 28.8023 9.27137 27.6941 8.52218 27.1924C7.76724 26.687 6.57668 26.7035 5.93656 26.0634C5.29649 25.4233 5.31293 24.2328 4.80749 23.4778C4.30593 22.7286 3.19762 22.2906 2.84812 21.4476C2.72824 21.1586 2.70762 20.8375 2.72381 20.5036L3.25156 20.0884H6.67549L6.14774 20.5036C6.13162 20.8376 6.15224 21.1586 6.27212 21.4477Z" fill="#FBC700"/>
            <path d="M17.6137 25.9456H16.2038L13.2743 24.692L10.6666 22.1594L9.82483 20.0884H24.6277L25.012 20.5036C23.5865 23.3444 20.8568 25.4211 17.6137 25.9456Z" fill="#F27182"/>
            <path d="M17.6135 25.9456C17.0878 26.0306 16.549 26.0763 15.9997 26.0763C12.0614 26.0763 8.64417 23.8049 6.98767 20.5036L7.43636 20.0884H10.6639L10.2152 20.5036C11.6407 23.3444 14.3704 25.4211 17.6135 25.9456Z" fill="#ED5469"/>
            <path d="M17.6135 23.3618H16.5471L14.1219 22.2668C14.1219 22.2668 13.3306 21.1023 12.651 20.0884H21.2258L22.0873 20.5036C21.0043 21.9341 19.4289 22.9708 17.6135 23.3618Z" fill="#ED5469"/>
            <path d="M17.6135 23.3618C17.0933 23.4738 16.5535 23.5331 15.9998 23.5331C13.5137 23.5331 11.3055 22.3439 9.91235 20.5036L10.4304 20.0884H13.658L13.1399 20.5036C14.2228 21.9341 15.7982 22.9708 17.6135 23.3618Z" fill="#E63850"/>
            <path d="M31.3591 11.4961H2.71101L2.3822 11.7075V20.0992L2.74758 20.5037H31.3591C31.713 20.5037 31.9999 20.2168 31.9999 19.863V12.1368C31.9999 11.7829 31.713 11.4961 31.3591 11.4961Z" fill="#FFE559"/>
            <path d="M2.537 19.8629V12.1368C2.537 11.7829 2.82388 11.4961 3.17775 11.4961H0.64075C0.286875 11.4961 0 11.7829 0 12.1368V19.8628C0 20.2167 0.286875 20.5035 0.64075 20.5035H3.17775C2.82388 20.5036 2.537 20.2168 2.537 19.8629Z" fill="#FFD500"/>
            <path d="M3.64201 14.4955C3.90869 14.4955 4.12488 14.2793 4.12488 14.0127C4.12488 13.746 3.90869 13.5298 3.64201 13.5298H2.08676C1.82007 13.5298 1.60388 13.746 1.60388 14.0127V17.9873C1.60388 18.2541 1.82007 18.4702 2.08676 18.4702H3.64207C3.90876 18.4702 4.12494 18.254 4.12494 17.9873C4.12494 17.7206 3.90876 17.5045 3.64207 17.5045H2.56963V16.4829H3.55563C3.82232 16.4829 4.03851 16.2667 4.03851 16C4.03851 15.7333 3.82232 15.5172 3.55563 15.5172H2.56963V14.4956L3.64201 14.4955Z" fill="#ED5469"/>
            <path d="M29.9134 17.5044H28.8411V16.4828H29.8271C30.0937 16.4828 30.3099 16.2667 30.3099 16C30.3099 15.7332 30.0937 15.5171 29.8271 15.5171H28.8411V14.4955H29.9134C30.1801 14.4955 30.3963 14.2793 30.3963 14.0127C30.3963 13.746 30.1801 13.5298 29.9134 13.5298H28.3581C28.0914 13.5298 27.8752 13.746 27.8752 14.0127V17.9873C27.8752 18.2541 28.0914 18.4702 28.3581 18.4702H29.9134C30.1801 18.4702 30.3963 18.254 30.3963 17.9873C30.3963 17.7205 30.1801 17.5044 29.9134 17.5044Z" fill="#ED5469"/>
            <path d="M14.0575 17.5045H12.9743V14.0127C12.9743 13.7459 12.7581 13.5298 12.4914 13.5298C12.2247 13.5298 12.0085 13.746 12.0085 14.0127V17.9873C12.0085 18.2541 12.2247 18.4702 12.4914 18.4702H14.0575C14.3242 18.4702 14.5404 18.254 14.5404 17.9873C14.5404 17.7206 14.3242 17.5045 14.0575 17.5045Z" fill="#ED5469"/>
            <path d="M10.9408 17.2513C10.6931 17.417 10.4053 17.5045 10.1086 17.5045C9.27905 17.5045 8.60424 16.8295 8.60424 16C8.60424 15.1705 9.27912 14.4956 10.1086 14.4956C10.4053 14.4956 10.6931 14.5831 10.9407 14.7487C11.1624 14.8967 11.4623 14.8372 11.6105 14.6155C11.7587 14.3938 11.6992 14.094 11.4774 13.9457C11.0704 13.6737 10.5971 13.5298 10.1086 13.5298C8.74655 13.5298 7.63843 14.6379 7.63843 16C7.63843 17.3622 8.74655 18.4703 10.1086 18.4703C10.5971 18.4703 11.0704 18.3264 11.4776 18.0543C11.6993 17.9061 11.7589 17.6062 11.6107 17.3845C11.4624 17.1628 11.1626 17.1032 10.9408 17.2513Z" fill="#ED5469"/>
            <path d="M20.4808 15.5486C19.7853 15.3654 19.4965 15.0802 19.4965 14.9682C19.4965 14.7812 19.7267 14.5205 20.1015 14.5205C20.5067 14.5205 20.8432 14.8507 20.8529 14.8604C21.0381 15.0502 21.3421 15.0552 21.5335 14.8709C21.7255 14.6859 21.7313 14.3802 21.5463 14.1881C21.4839 14.1233 20.9129 13.5547 20.1016 13.5547C19.2355 13.5547 18.5308 14.1887 18.5308 14.9682C18.5308 15.6452 19.1519 16.1972 20.2348 16.4826C20.7845 16.6274 20.7845 16.8334 20.7845 17.0151C20.7845 17.2016 20.5875 17.4793 20.0447 17.4793C19.6191 17.4793 19.3672 17.2635 19.255 17.1349C19.0795 16.934 18.7746 16.9133 18.5736 17.0886C18.3727 17.264 18.3519 17.569 18.5273 17.7699C18.7473 18.0221 19.2371 18.4451 20.0447 18.4451C21.1525 18.4451 21.7503 17.7083 21.7503 17.0151C21.7503 16.2639 21.3232 15.7706 20.4808 15.5486Z" fill="#ED5469"/>
            <path d="M17.6487 13.5298C17.382 13.5298 17.1658 13.746 17.1658 14.0127V16.667C17.1658 17.1288 16.7901 17.5045 16.3283 17.5045C15.8666 17.5045 15.4909 17.1288 15.4909 16.667V14.0127C15.4909 13.7459 15.2747 13.5298 15.008 13.5298C14.7413 13.5298 14.5251 13.746 14.5251 14.0127V16.667C14.5251 17.6613 15.3341 18.4703 16.3284 18.4703C17.3227 18.4703 18.1316 17.6613 18.1316 16.667V14.0127C18.1316 13.746 17.9154 13.5298 17.6487 13.5298Z" fill="#ED5469"/>
            <path d="M22.7667 13.5298C22.5 13.5298 22.2838 13.746 22.2838 14.0127V17.9873C22.2838 18.2541 22.5 18.4702 22.7667 18.4702C23.0334 18.4702 23.2496 18.254 23.2496 17.9873V14.0127C23.2496 13.746 23.0334 13.5298 22.7667 13.5298Z" fill="#ED5469"/>
            <path d="M27.272 13.5606C27.0222 13.4671 26.744 13.5939 26.6505 13.8436L25.6157 16.6095L24.5808 13.8436C24.4874 13.5938 24.2092 13.4671 23.9593 13.5606C23.7096 13.654 23.5828 13.9323 23.6762 14.1821L25.1634 18.1567C25.2339 18.3454 25.4142 18.4704 25.6156 18.4704C25.817 18.4704 25.9973 18.3454 26.0679 18.1567L27.555 14.1821C27.6486 13.9322 27.5218 13.654 27.272 13.5606Z" fill="#ED5469"/>
            <path d="M6.7113 16.0001L7.78693 14.2675C7.92762 14.0409 7.85793 13.7432 7.63137 13.6025C7.4048 13.4619 7.10705 13.5316 6.96643 13.7581L6.14287 15.0845L5.31937 13.7581C5.17868 13.5315 4.88099 13.4618 4.65443 13.6025C4.4278 13.7432 4.35818 14.0409 4.49887 14.2675L5.57449 16.0001L4.49887 17.7328C4.35818 17.9594 4.42787 18.2571 4.65443 18.3978C4.73374 18.447 4.82174 18.4705 4.90862 18.4705C5.07012 18.4705 5.22793 18.3895 5.31937 18.2422L6.14287 16.9158L6.96637 18.2422C7.0578 18.3895 7.21562 18.4705 7.37712 18.4705C7.46405 18.4705 7.55205 18.447 7.6313 18.3978C7.85793 18.2571 7.92755 17.9594 7.78687 17.7328L6.7113 16.0001Z" fill="#ED5469"/>
            </g>
            <defs>
            <clipPath id="clip0_11630_12171">
            <rect width="32" height="32" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            ${category.name}
          `;
        } else {
          // Just the name for other tabs
          tab.textContent = category.name;
        }

        if (index === 0) {
          tab.classList.add('active');
          populateSlider(imagesForSlider);
        }

        tab.addEventListener('click', () => {
          tabListContainer.querySelectorAll('.card-type-tab').forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          
          const images = categoryImageData.get(category._id);
          populateSlider(images);
        });

        tabListContainer.appendChild(tab);
      });
      //END: Dynamic Tab Logic

      // AFTER the loop, check the flag and show the icon
      if (lordsInfoWrapper && lordsCategoryExists) {
        lordsInfoWrapper.style.display = 'flex';
      }

      prevBtn.addEventListener('click', () => {
        if (slides.length === 0) return;
        currentSlide = (currentSlide - 1 + slides.length) % slides.length;
        updateSlide();
      });

      nextBtn.addEventListener('click', () => {
        if (slides.length === 0) return;
        currentSlide = (currentSlide + 1) % slides.length;
        updateSlide();
      });

      amountBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          amountBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const value = btn.dataset.value;
          customAmountInput.classList.toggle('hidden', value !== 'custom');
          giftCardData.amount = (value === 'custom') ? parseFloat(customAmountInput.value) || null : parseFloat(value);
        });
      });

      customAmountInput.addEventListener('input', () => {
        giftCardData.amount = parseFloat(customAmountInput.value) || null;
      });

      sendAsGiftCheckbox.addEventListener('change', () => {
        const isChecked = sendAsGiftCheckbox.checked;
        recipientFields.classList.toggle('hidden', !isChecked);
        giftCardData.sendAsGift = isChecked;
        recipientNameInput.required = isChecked;
        recipientEmailInput.required = isChecked;
        if (!isChecked) {
          videoCheckbox.checked = false;
          giftCardData.addVideo = false;
          giftCardForm.reset();
          document.querySelector('.custom-gc-delivery-btn[data-delivery="now"]').classList.add('active');
          document.querySelector('.custom-gc-delivery-btn[data-delivery="later"]').classList.remove('active');
          if (typeof updateMessageCounter === 'function') {
            updateMessageCounter();
          }
        }
      });

      const datePickerWrapper = document.getElementById('delivery-date-wrapper');
      deliveryBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          deliveryBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const deliveryType = btn.dataset.delivery;
          giftCardData.delivery.type = deliveryType;
          const isDeliverLater = deliveryType === 'later';
          datePickerWrapper.classList.toggle('hidden', !isDeliverLater);
          datePickerInput.required = isDeliverLater;
          if (isDeliverLater) {
            setMinDateTime();
            giftCardData.delivery.dateTime = datePickerInput.value || null;
          } else {
            giftCardData.delivery.dateTime = null;
            datePickerInput.value = '';
          }
        });
      });

      datePickerInput.addEventListener('change', (event) => {
        giftCardData.delivery.dateTime = event.target.value || null;
      });

      agreeCheckbox.addEventListener('change', updateAddToCartButtonState);

      modalContinueBtn.addEventListener('click', () => {
        resetGiftCardForm();
        hideModal();
      });

      // Form submission logic
      giftCardForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!giftCardData.amount || giftCardData.amount <= 0) {
          showModal('Please select or enter a valid gift card amount.', 'error');
          return;
        }
        
        showModal('Adding your Gift Card...', 'loading');
        addToCartBtn.disabled = true;
        giftCardData.addVideo = videoCheckbox.checked;
        if (giftCardData.sendAsGift) {
          giftCardData.recipient.name = recipientNameInput.value;
          giftCardData.recipient.email = recipientEmailInput.value;
          giftCardData.recipient.message = recipientMessageInput.value;
        }

        const videoAddOnAmount = 5;
        let totalAmount = giftCardData.amount;
        if (giftCardData.addVideo && giftCardData.sendAsGift) {
          totalAmount += videoAddOnAmount;
        }
        try {
          const variantResponse = await fetch('https://gift-card-functionality-production.up.railway.app/api/gc/variant', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ amount: totalAmount })
          });
          if (!variantResponse.ok) throw new Error('Could not create gift card variant.');
          const { variantId } = await variantResponse.json();
          if (!variantId) throw new Error('Invalid variant ID received.');
          const properties = {
            'Gift Card Type': giftCardData.cardType,
            'Amount': `£${giftCardData.amount.toFixed(2)}`,
            '_image': giftCardData.imageUrl,
            '_giftCardDetails': JSON.stringify(giftCardData)
          };
          if (giftCardData.addVideo && giftCardData.sendAsGift) {
            properties['Add a Video Message'] = 'True';
          }
          if (giftCardData.sendAsGift) {
            properties['Recipient Name'] = giftCardData.recipient.name;
            properties['Recipient Email'] = giftCardData.recipient.email;
            if (giftCardData.recipient.message) properties['Message'] = giftCardData.recipient.message;
            if (giftCardData.delivery.type === 'later' && giftCardData.delivery.dateTime) {
              const [datePart, timePart] = giftCardData.delivery.dateTime.split('T');
              const [year, month, day] = datePart.split('-');
              properties['Delivery'] = `Scheduled for ${day}/${month}/${year}, ${timePart}`;
            } else {
              properties['Delivery'] = 'Immediately';
            }
          }
          const initialAddResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
          });
          if (!initialAddResponse.ok) {
            const errorData = await initialAddResponse.json();
            throw new Error(errorData.description || 'Failed to add item to cart.');
          }
          const addedItem = await initialAddResponse.json();
          if (!addedItem || !addedItem.key) {
            throw new Error('Could not identify the item added to the cart.');
          }
          const expectedPriceInCents = Math.round(totalAmount * 100);
          const pollResult = await pollForCartUpdate(addedItem.key, expectedPriceInCents);
          if (pollResult.success) {
            resetGiftCardForm();
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble) {
              const countEl = cartIconBubble.querySelector('span[aria-hidden="true"]');
              if (countEl) countEl.textContent = pollResult.cart.item_count;
            }
            showModal('Added to your cart!', 'success');
          } else {
            throw new Error(pollResult.error || 'The item could not be added correctly. Please try again.');
          }
        } catch (error) {
          console.error('Error adding gift card to cart:', error);
          showModal(error.message || 'An error occurred. Please try again or contact support.', 'error');
        } finally {
          addToCartBtn.disabled = false;
        }
      });

      // Check balance logic
      checkBalanceBtn.addEventListener('click', async () => {
        const code = checkBalanceInput.value.trim();
        if (!code) {
          balanceResultDisplay.textContent = 'Please enter a gift card code.';
          return;
        }
        checkBalanceBtn.disabled = true;
        balanceResultDisplay.textContent = 'Checking...';
        try {
          const response = await fetch('https://gift-card-functionality-production.up.railway.app/api/gc/check-balance', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code }) });
          const result = await response.json();
          if (!response.ok) {
            balanceResultDisplay.textContent = 'Gift card not found.';
          } else {
            const formattedBalance = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(result.balance);
            balanceResultDisplay.innerHTML = `Remaining Balance: <span class="highlighted-balance">${formattedBalance}</span>`;
          }
        } catch (error) {
          console.error('Check balance error:', error);
          balanceResultDisplay.textContent = 'An error occurred. Please try again.';
        } finally {
          checkBalanceBtn.disabled = false;
        }
      });

      
      // URL Hash Logic
      function activateTabById(tabId) {
        const tabToClick = tabListContainer.querySelector(`.card-type-tab[data-tab-id="${tabId}"]`);
        
        if (tabToClick) {
          tabToClick.click();
        } else {
          const firstTab = tabListContainer.querySelector('.card-type-tab');
          if (firstTab) {
            firstTab.click();
          }
        }
      }

      const urlHash = window.location.hash;

      if (urlHash === '#lords') {
        activateTabById('lords');
      } else {
        activateTabById('digital');
      }

      window.addEventListener('hashchange', () => {
        const newHash = window.location.hash;
        if (newHash === '#lords') {
          activateTabById('lords');
        } else {
          activateTabById('digital');
        }
      });
      // END: URL Hash Logic

      updateAddToCartButtonState();

    })
    .catch(error => {
      console.error("Error loading gift card categories:", error);
      if (sliderImagesContainer) {
        sliderImagesContainer.innerHTML = '<p>Could not load gift card designs.</p>';
      }
    });
});
